define.alias("shared/components/shared/carousel/controls", "preview-grid/components/shared/carousel/controls");